/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-19 21:30 VN — WEB-20261019-suzitee-cart-pawfect
   Đã làm: đồng hồ "Your cart will expire in MM:SS minutes!" cho giỏ (drawer + /cart), chép đúng cách pawfecthouse chạy:
   - 1 hạn chót chung cho cả tab (sessionStorage 'sz_cart_hold_deadline_ms'), nên chuyển trang / mở lại drawer vẫn đếm tiếp, không về 10:00.
   - Chưa có hạn chót hoặc hạn đã qua → đặt mới = bây giờ + 10 phút (data-sz-cd-sec) khi khung đồng hồ xuất hiện.
   - Về 00:00 → thay chữ bằng câu nhắc "Forgot one final step?…" và xoá hạn chót; lần sau khung được vẽ lại (đổi giỏ, tải trang) đếm lại 10:00.
   - Giỏ rỗng → xoá hạn chót (thêm hàng lần sau bắt đầu 10:00).
   CHỈ đổi chữ hiển thị: KHÔNG gọi API giỏ, KHÔNG xoá/ẩn sản phẩm nào.
   Thay script jQuery cũ trong snippets/countdown.liquid + hàm tickTimer trong sz_minicart.js (hàm đó tự thoát vì không còn .countdown_time). */
(function () {
  'use strict';
  if (window.__szCd) return; window.__szCd = 1;
  var KEY = 'sz_cart_hold_deadline_ms', deadline = NaN;
  function get() { try { return parseInt(sessionStorage.getItem(KEY), 10); } catch (e) { return NaN; } }
  function set(v) { try { sessionStorage.setItem(KEY, String(v)); } catch (e) {} }
  function del() { try { sessionStorage.removeItem(KEY); } catch (e) {} }
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function tick() {
    try {
      var els = document.querySelectorAll('[data-sz-cd]');
      if (!els.length) { if (document.querySelector('[data-szmc-count="0"]')) del(); return; }
      var now = Date.now(), i, el;
      for (i = 0; i < els.length; i++) {
        el = els[i];
        if (el.__szcd) continue;
        el.__szcd = 1;
        deadline = get();
        if (!(deadline > now)) { deadline = now + (parseInt(el.getAttribute('data-sz-cd-sec'), 10) || 600) * 1000; set(deadline); }
      }
      if (!(deadline > 0)) return;
      var left = deadline - now;
      if (left <= 0) {
        for (i = 0; i < els.length; i++) {
          el = els[i];
          if (el.__szcdEnd) continue;
          el.__szcdEnd = 1;
          var p = el.querySelector('.sz-cd__txt'), msg = el.getAttribute('data-sz-cd-end');
          if (p && msg) p.textContent = msg;
          el.classList.add('is-ended');
        }
        deadline = NaN; del();
        return;
      }
      var s = Math.floor(left / 1000), txt = pad(Math.floor(s / 60)) + ':' + pad(s % 60);
      for (i = 0; i < els.length; i++) {
        if (els[i].__szcdEnd) continue;
        var t = els[i].querySelector('.sz-cd__t');
        if (t && t.textContent !== txt) t.textContent = txt;
      }
    } catch (e) {}
  }
  tick();
  setInterval(tick, 1000);
  document.addEventListener('DOMContentLoaded', tick);
})();

/* CARTALMA-BEGIN — AI Agent làm theo chỉ thị của anh Hoá — 2026-10-20 12:50 VN — WEB-20261020-suzitee-cartalma
   Đã làm: nút − của ô số lượng kiểu almagems (.product-quantity-box.sz-qba) MỜ khi số lượng = 1, như almagems (nút "disabled").
   Liquid đặt class is-min lúc vẽ dòng; ở đây chỉ đồng bộ lại sau khi khách bấm −/+ hoặc gõ số (sz_minicart.js đổi input.value bằng JS,
   CSS không đọc được). Nghe 'click' pha CAPTURE trên window (chạy TRƯỚC handler capture của drawer/trang giỏ, không chặn gì) rồi rAF đọc số mới;
   kiểm lại sau 1.2s/3s (khi server trả số thật). Chỉ toggle khi trạng thái đổi; không observer, không gọi API. Kiểu pawf: không có .sz-qba → không làm gì. */
(function () {
  'use strict';
  if (window.__szQbaMin) return; window.__szQbaMin = 1;
  function sync(box) {
    try {
      var i = box.querySelector('input.quantity'), m = box.querySelector('.product-minus'); if (!i || !m) return;
      var on = (parseInt(i.value, 10) || 1) <= 1;
      if (m.classList.contains('is-min') !== on) m.classList.toggle('is-min', on);
    } catch (e) {}
  }
  function later(box) { requestAnimationFrame(function () { sync(box); }); setTimeout(function () { sync(box); }, 1200); setTimeout(function () { sync(box); }, 3000); }
  function onEv(e) { var t = e.target, box = t && t.closest && t.closest('.sz-qba'); if (box) later(box); }
  window.addEventListener('click', onEv, true);
  window.addEventListener('change', onEv, true);
})();
/* CARTALMA-END */
